<template>
  <div
    ref="wrap"
    class="scale-wrap"
    @dblclick="onDblclick"
    @dbltouch="onDblclick"
  >
    <div
      ref="zoom"
      class="scale-content"
      @panzoomzoom="onZoom"
      @panzoompan="onPan"
    >
      <img
        :src="src"
        :alt="alt"
        @contextmenu.prevent
      >
    </div>
  </div>
</template>

<script>
import Panzoom from '@panzoom/panzoom'
import { useDbltouch } from '@/utils/dbltouch'

/**
 * Emitted Events:
 *   @scale="scale"
 *   @zoom="{ x, y }"
 */
export default {
  props: {
    src: {
      type: String,
      default: '',
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    disableZoom: {
      type: Boolean,
      default: false
    },
    scale: {
      type: Number,
      default: 1
    },
    minScale: {
      type: Number,
      default: 1
    },
    maxScale: {
      type: Number,
      default: 5
    }
  },
  data: () => ({
    panzoom: null,
    zoomEl: null,
    parentEl: null
  }),
  watch: {
    scale (val) {
      this.panzoom && this.panzoom.zoom(val)
    }
  },
  mounted () {
    this.setEvent()
    this.initPanzoom()
  },
  beforeDestroy () {
    this.parentEl.removeEventListener('wheel', this.panzoom.zoomWithWheel)
    this.parentEl.removeEventListener('gesturestart', this.onGesture)
    this.parentEl.removeEventListener('gesturechange', this.onGesture)
    this.parentEl.removeEventListener('gestureend', this.onGesture)
    this.panzoom && this.panzoom.destroy()
  },
  methods: {
    setEvent () {
      const el = this.$refs.wrap
      useDbltouch(el)
    },
    initPanzoom () {
      this.zoomEl = this.$refs.zoom
      this.panzoom = Panzoom(this.zoomEl, {
        step: 0.1,
        disableZoom: this.disableZoom,
        startScale: this.scale,
        minScale: this.minScale,
        maxScale: this.maxScale,
        panOnlyWhenZoomed: true
      })
      this.parentEl = this.zoomEl.parentElement
      this.parentEl.addEventListener('wheel', this.panzoom.zoomWithWheel)
      this.parentEl.addEventListener('gesturestart', this.onGesture)
      this.parentEl.addEventListener('gesturechange', this.onGesture)
      this.parentEl.addEventListener('gestureend', this.onGesture)
    },
    onZoom (e) {
      // e.detail = { x: 0, y: 0, scale: 1 }
      const scale = e.detail.scale
      if (scale === 1) {
        this.reset()
      }
      this.$emit('scale', scale)
      this.$emit('update:scale', scale)
    },
    onPan (e) {
      this.$emit('pan', {
        x: e.detail.x,
        y: e.detail.y
      })
    },
    onDblclick () {
      if (!this.panzoom) {
        return
      }
      if (this.scale === 1) {
        this.panzoom.zoom(2)
      } else {
        this.reset()
      }
    },
    reset () {
      if (!this.panzoom) {
        return
      }
      this.panzoom.reset()
      const scale = this.panzoom.getScale()
      this.$emit('scale', scale)
      this.$emit('update:scale', scale)
      this.$emit('pan', this.panzoom.getPan())
    },
    // On Safari with touchpad
    onGesture (e) {
      // e.preventDefault()
      const scale = this.panzoom.getScale()
      // scale *= e.scale
      this.panzoom.zoom(scale)
    }
  }
}
</script>

<style lang="stylus" scoped>
.scale-wrap {
  display: flex
  justify-content: center
  align-items: center
}
.scale-content {
  position: relative
  width: 100%
  height: 100%
}
img {
  display: block
  max-width: 100%
  max-height: 100%
  position: absolute
  margin: auto
  top: 0
  left: 0
  right: 0
  bottom: 0
}
</style>
